import { gql } from '@apollo/client';

export const BRAND_NAMES = gql`
  query getAvailableBrandNames($inputBrandName: String!) {
    getAvailableBrandNames(inputBrandName: $inputBrandName)
  }
`;
